<template>
  <div class="h-full overflow-y-auto p-4 md:p-8">
    <div class="max-w-3xl mx-auto">
      <h2 class="font-display text-3xl">The eight layers of flavour</h2>
      <p class="text-sm text-ink-dim mt-2 leading-relaxed max-w-2xl">
        Every note in a glass of wine comes from one of eight layers, from the
        grape's genetics to the years in bottle. The variety sets the repertoire;
        each later layer decides which parts of it show, and adds notes of its
        own. The <button class="text-gold-bright hover:underline" @click="store.view = 'wine'">Taste a wine</button>
        analysis tags every note and compound with the layer it comes from.
      </p>

      <div class="mt-8 flex flex-col gap-5">
        <section v-for="(l, i) in LAYERS" :key="l.id" class="panel overflow-hidden">
          <div class="h-1" :style="{ background: l.color }" />
          <div class="p-5">
            <div class="flex items-baseline gap-3">
              <span class="font-display text-ink-faint text-sm">{{ i + 1 }}</span>
              <h3 class="font-display text-2xl" :style="{ color: l.color }">{{ l.label }}</h3>
              <p class="font-display italic text-sm text-ink-dim">{{ l.essence }}</p>
            </div>
            <p class="text-sm text-ink-dim leading-relaxed mt-3">{{ l.body }}</p>

            <div class="flex flex-wrap items-center gap-1.5 mt-4">
              <span class="text-[0.65rem] uppercase tracking-[0.18em] text-ink-faint mr-1">Listen for</span>
              <span v-for="d in l.listen_for" :key="d" class="chip">{{ pretty(d) }}</span>
            </div>
            <div class="flex flex-wrap items-center gap-1.5 mt-2">
              <span class="text-[0.65rem] uppercase tracking-[0.18em] text-ink-faint mr-1">Key chemistry</span>
              <button v-for="c in l.compounds" :key="c" @click="goCompound(c)"
                class="chip gold hover:bg-gold/15 cursor-pointer">{{ compoundName(c) }}</button>
            </div>
          </div>
        </section>
      </div>

      <p class="text-xs text-ink-faint italic mt-6 mb-2">
        Two honest omissions: clonal variation (a sub-layer of Variety) and the serving
        context — temperature, glass, food — which changes the taster, not the wine.
      </p>
    </div>
  </div>
</template>

<script setup>
import { store } from "../store"
import { LAYERS } from "../layers"

const pretty = s => s.replace(/-/g, " ")

function compoundName(slug) {
  const c = store.compounds.find(x => x.slug === slug)
  if (!c) return slug
  // keep names short on chips
  return c.name.length > 26 ? (c.name.match(/\(([^)]+)\)/)?.[1] || c.name.slice(0, 24) + "…") : c.name
}

function goCompound() {
  store.view = "compounds"
}
</script>
